var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 57.24 57.2",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.46 10.11C33.3-10 .17 1.89 0 28.58A28.72 28.72 0 0 0 28.62 57.2c24.44-.06 37.44-28.79 21.84-47.09zm-37.41 40c-12.89-9-14.75-28.28-4-39.59C26.61-8.25 58 6.07 55 31.83 52.7 51.79 29.21 62 13.05 50.15z",
    fill: "#dd3751",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.62 8.06a20.53 20.53 0 0 0-7.06 39.8 20.58 20.58 0 0 0 14.1 0 20.56 20.56 0 0 0 13.45-20 19.25 19.25 0 0 0-.22-2.43A20.55 20.55 0 0 0 28.62 8.06zm15 9.66a18.42 18.42 0 0 1 3.1 6.89 13 13 0 0 0-9.82 1.08 8.32 8.32 0 0 0-.48-1.46l6.33-1.55-.47-1.94-6.92 1.7a8.67 8.67 0 0 0-1.7-1.67 29.15 29.15 0 0 0 9.96-3.05zm-8.51 9.86c-.39 9-13.51 8.33-12.95-.69 1.07-8.06 12.77-7.44 12.95.69zm-6.49-17.52a18.5 18.5 0 0 1 13.7 6.06c-7 3.91-20.42 3.91-27.4 0a18.5 18.5 0 0 1 13.7-6.06zm-15 7.66a29.15 29.15 0 0 0 10 3.05 8.67 8.67 0 0 0-1.7 1.67L15 20.74l-.47 1.94 6.33 1.55a9.24 9.24 0 0 0-.48 1.46 13 13 0 0 0-9.82-1.08 18.42 18.42 0 0 1 3.06-6.89zm7.63 27.86a18.58 18.58 0 0 1-11.07-18.75 11.1 11.1 0 0 1 10 1.06A8.49 8.49 0 0 0 25 35.26a11.06 11.06 0 0 1-3.75 10.32zm7.37 1.53a18.63 18.63 0 0 1-5.26-.76 13 13 0 0 0 3.75-10.42l.51.07v7.53h2V36l.51-.07a13 13 0 0 0 3.75 10.42 18.63 18.63 0 0 1-5.26.76zM36 45.58a11.06 11.06 0 0 1-3.75-10.32 8.49 8.49 0 0 0 4.86-7.37 11.1 11.1 0 0 1 10-1.06A18.58 18.58 0 0 1 36 45.58z",
    fill: "#dd3751",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteering);
export default __webpack_public_path__ + "static/media/steering.11769b8f732b4cc45b88898757b79e55.svg";
export { ForwardRef as ReactComponent };